module.exports = __webpack_public_path__ + "static/media/studio-slide4.d117d3d9.png";